var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',[_vm._v("My "),_c('i',{staticClass:"fab fa-instagram"}),_vm._v(" Gallery")])])}]

export { render, staticRenderFns }